import styled, { css } from 'styled-components';

export const StyledSection = styled.section`
  ::after {
    content: '';
    background-color: white;
    height: 260px;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
  }
`;

export const CarouselItem = styled.div`
  max-width: 520px;
`;

const overlay = css`
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 20px;
  background-color: white;
  opacity: 0.8;
  height: 480px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 380px;
  }
`;

export const CarouselContainer = styled.div<{ active: 1 | 2 | 3 }>`
  height: 440px;
  > div:nth-child(1) {
    z-index: ${({ active }) => (active !== 1 ? 1 : 2)};
    transition: 0.5s;
    transform: ${({ active }) => getTransformation(active, 1, '300px')};

    ${({ theme }) => theme.breakpoints.up('sm')} {
      transform: ${({ active }) => getTransformation(active, 1, '520px')};
    }

    ::after {
      ${({ active }) => (active !== 1 ? overlay : undefined)}
    }
  }
  > div:nth-child(2) {
    z-index: ${({ active }) => (active !== 2 ? 1 : 2)};
    transition: 0.5s;
    transform: ${({ active }) => getTransformation(active, 2, '300px')};

    ${({ theme }) => theme.breakpoints.up('sm')} {
      transform: ${({ active }) => getTransformation(active, 2, '520px')};
    }

    ::after {
      ${({ active }) => (active !== 2 ? overlay : undefined)}
    }
  }
  > div:nth-child(3) {
    z-index: ${({ active }) => (active !== 3 ? 1 : 2)};
    transition: 0.5s;
    transform: ${({ active }) => getTransformation(active, 3, '300px')};

    ${({ theme }) => theme.breakpoints.up('sm')} {
      transform: ${({ active }) => getTransformation(active, 3, '520px')};
    }

    ::after {
      ${({ active }) => (active !== 3 ? overlay : undefined)}
    }
  }
`;

const getTransformation = (
  active: 1 | 2 | 3,
  item: 1 | 2 | 3,
  amount: string,
): string => {
  if (active === item) {
    return 'none';
  }
  if (active === 1 && item === 2) {
    return `translateX(${amount}) scale(0.8)`;
  }
  if (active === 1 && item === 3) {
    return `translateX(-${amount}) scale(0.8)`;
  }
  if (active === 2 && item === 1) {
    return `translateX(-${amount}) scale(0.8)`;
  }
  if (active === 2 && item === 3) {
    return `translateX(${amount}) scale(0.8)`;
  }
  if (active === 3 && item === 1) {
    return `translateX(${amount}) scale(0.8)`;
  }
  if (active === 3 && item === 2) {
    return `translateX(-${amount}) scale(0.8)`;
  }
  return 'none';
};

export const StyledCard = styled.div`
  height: 480px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 380px;
  }
`;
